import React from 'react'

export const ignoreEnter = (e: React.KeyboardEvent<HTMLFormElement>) => {
  if (e.code === 'Enter') {
    e.preventDefault()
  }
}
